import { throttle } from 'lodash';
import { gtmTracker } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { getQueryParam } from '../../query-params/queryParamUtils';
import { MISSED_TOKEN_TIMEOUT } from './missedTokenTimeout';

export const notifyIfNotReceivedToken = throttle(
    () => {
        const search = window.location.search;
        const userHash = getQueryParam(search, 'current_user');
        const accountId = getQueryParam(search, 'accountId');
        gtmTracker.trackError(new Error(`Missed parent token user - ${userHash}, accountId - ${accountId}`));
    },
    MISSED_TOKEN_TIMEOUT,
    { leading: false }
);
